import React, { useCallback } from "react";
import SettingsTab from "./SettingsTab";

function SurveySettingsSection({ settings, setSettings }) {
  const handleSettingsChange = useCallback(
    (field, value) => {
      console.log(`Settings changed - ${field}:`, value);
      if (field === "surveyColour") {
        console.log("SurveyColour object being set:", value);
      }
      setSettings((prev) => ({
        ...prev,
        [field]: value,
      }));
    },
    [setSettings]
  );

  return (
    <SettingsTab
      settings={settings}
      handleSettingsChange={handleSettingsChange}
    />
  );
}

export default SurveySettingsSection;
